import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import styledComponent from "styled-components"

const ButtonBase = styledComponent.span`
    cursor: pointer;
    color: #2980b9;
    font-family: "Avenir Next";
    white-space: nowrap;
    text-align: center;
    font-size: 10pt;
    line-height: 45px;
    padding: 12px 14px 9px;
    transition: all 0.1s ease-in-out;
    border-radius: ${props => props.theme.borderRadius || "0px"};
    &.small {
        padding: 3px 5px;
        line-height: 20px;
    }
    &.large {
        padding: 20px 25px;
        line-height: 60px;
    }
    &.disabled,
    &:disabled,
    &.disabled:hover,
    &:disabled:hover {
        cursor: not-allowed;
        opacity: 0.8;
        text-decoration: none;
    }
    &:active {
        opacity: 0.95;
    }
    &.round {
        border-radius: ${props => (props.theme.borderRadius ? "50%" : "0px")};
    }
    &.round.withChildren {
        border-radius: ${props => (props.theme.borderRadius ? "20px" : "0px")};
    }

    &.withIcon.withChildren .icon {
        margin-right: 5px;
    }
    &.type-default {
        line-height: 20px;
        padding: 0 3px;
        &:hover:not(.disabled),
        &.active {
            text-decoration: underline;
        }
    }
    &.type-primary {
        ${({ theme }) => theme.__primary};
    }
    &.type-danger {
        ${({ theme }) => theme.__danger};
    }
    &.type-success {
        ${({ theme }) => theme.__success};
    }
    &.type-info {
        ${({ theme }) => theme.__info};
    }
    &.type-warning {
        ${({ theme }) => theme.__warning};
    }
    &.materialAdd {
        color: white;
        font-size: 18pt;
        line-height: 30px;
        height: 50px;
        width: 50px;
        padding: 12px 14px 9px;
        border-radius: 100px;
        &.disabled,
        &[disabled] {
            cursor: not-allowed;
            opacity: 0.8;
            text-decoration: none;
        }
        &:active {
            opacity: 0.95;
        }
        background: #2db5c3;
        box-shadow: 0px 2px 5px #666;
    }
`

// remember, this is a thing: Element.extend.attrs({key: value})
const Button = props => {
    let {
        icon,
        type = "default",
        active,
        disabled,
        size,
        round,
        children,
        primary,
        danger,
        className,
        materialAdd,
        ...otherProps
    } = props
    if (primary || danger) {
        type = primary ? "primary" : "danger"
        console.warn(
            `[Deprecated]: do not write <Button ${type}>, but <Button type="${type}"> instead`
        )
    }

    const classNames = cx(className, {
        ["type-" + type]: type,
        active,
        disabled,
        [size]: size,
        round,
        ["icon-" + icon]: !!icon,
        withIcon: !!icon,
        withChildren: !!children,
        materialAdd,
    })

    if (disabled) otherProps.onClick = undefined

    const onClick = otherProps.onClick

    if (onClick) {
        otherProps.onClick = event => {
            event.stopPropagation()
            onClick(event)
        }
    }

    return (
        <ButtonBase className={classNames} role="button" {...otherProps}>
            {icon && <i className={`icon fa fa-${icon}`} />}
            {children}
        </ButtonBase>
    )
}

Button.propTypes = {
    icon: PropTypes.string,
    type: PropTypes.oneOf(["primary", "danger", "success", "warning", "info"]),
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    materialAdd: PropTypes.bool,
    size: PropTypes.oneOf(["large", "small"]),
    onClick: PropTypes.func.isRequired,
}

/** @component */
export default Button



// WEBPACK FOOTER //
// ./src/ui/legacy/Button.js